import React, { useState, useRef } from "react";
import { Grid, Input, MenuItem, Select, InputLabel, Typography } from "@mui/material";
import SignatureCanvas from 'react-signature-canvas'
import Button from '@mui/material/Button';
import ClearIcon from '@mui/icons-material/Clear';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import Paper from '@mui/material/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TextField from '@mui/material/TextField';


const FinishDetails = ({
    isFormInvalid,
    current_booking_id,
    setSignatureFilled,
    signatureFilled,
    edit_mode,
    comment,
    setComment,
    setSignatureBytes
}) => {

    let sigPad = {}

    const clear = () => {
        sigPad.clear();
        setSignatureFilled(false);
    }

    const beginSignature = () => {
        if (!edit_mode) {
            setSignatureFilled(true);
        }
    }

    const endSignature = () => {
        let bytes = []
        const dataURL = sigPad.toDataURL();
        const base64Data = dataURL.split(',')[1];
        const binaryString = atob(base64Data);

        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        setSignatureBytes(bytes);
    }

    return (
        <div class="step-container">
            <Paper style={{ marginBottom: "20px" }} >
                <Grid container direction="row" justifyContent="center" alignItems="center">
                    <Grid item >
                        <img src={`${process.env.PUBLIC_URL}/member.png`} height={125}></img>
                    </Grid>
                    <Grid item xs={6} justifyContent='center' textAlign={'center'}>
                        <img src={`${process.env.PUBLIC_URL}/lines.png`} height={200}></img>
                    </Grid>
                    <Grid item >
                        <img src={`${process.env.PUBLIC_URL}/concil.jpg`} height={125}></img>
                    </Grid>
                </Grid>
                <Grid container direction="row" justifyContent="left" alignItems="center">
                    <Grid item xs={12}>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="h5" color="text.primary" align="left">
                                    APPENDIX 1 – SCHOOL RULES
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● Upon arrival, all valuables such as passport, flight ticket, medical insurance etc. as well as 100 GBP refundable security deposit is to be given to LINES staff
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● Students can keep their mobiles phones, but are not allowed to use them during lessons and activities
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● Respect the complete immersion at the centre and respect the other students and LINES staff
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● All property of LINES and of the campus are to be treated with care
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● No smoking, drinking of alcohol or drug taking is permitted on campus
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● The student may not leave the campus without prior permission from the parent/guardian and the Centre Manager
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● The student is not allowed to change rooms without prior permission from the Centre Manager
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● The student is to attend classes, activities, meals, excursions and meetings on time and to comply with all safety instructions
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● The use of hairsprays and /or deodorizers is not permitted in the student's room
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● The student is not allowed to enter the dorms of the opposite gender nor to leave his/her room after curfew
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● First aid is only by means of assessment of the child's injury or ailment. First aiders employed by LINES have no capacity to diagnose or prescribe medication
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● By signing this document, you allow the first aiders to administer your child basic medication such as paracetamol, ibuprofen, cough medicine, throat lozenge's etc.
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● By signing this document, you allow your child to be photographed during his/her stay and for images to be used for promotional use, including on social media
                                    </Typography>
                                </Grid>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● By signing this document, you allow us to use the email addresses mentioned for promotional use only
                                    </Typography>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="h5" color="text.primary" align="left">
                                    APPENDIX 2 – DATA PROTECTION
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography variant="body1" color="text.secondary" align="left">
                                    We promise to keep this information secure and will only give it to people who are directly involved in caring for your child on a need-to-know basis during the time when they are enrolled on the programme; this may include healthcare and welfare professionals.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="h5" color="text.primary" align="left">
                                    APPENDIX 3 – CONDITIONS OF BOOKING
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography marginBottom={2}>
                                    NO CONTRACT EXISTS UNTIL THE ENROLMENT FORM AND THE MEDICAL FORM ARE COMPLETED AND SIGNED BY THE CUSTOMER
                                </Typography>
                                <Typography marginBottom={1}>
                                    ALL BOOKINGS ARE SUBJECT TO THESE CONDITIONS AND TO THE LAW AND JURISIDICTION WHERE LINES IS BASED :
                                </Typography>
                                <Grid xs={12}>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● The balance of any total price due must be paid by the Customer at least 4 weeks before the beginning of the course
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● The deposit must be paid 1 week after the confirmation documents have been sent
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● An invoice for the balance(s) due will be sent to the Customer at least 4 weeks before the beginning of the course
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" align="left" marginBottom={2}>
                                        ● Cancellation of a booking is only effective when received in writing from the person signing the form
                                    </Typography>
                                    <Typography align="left">
                                        SCALE OF CANCELLATION CHARGES:
                                    </Typography>
                                    <Typography variant="body2" color="text.primary" align="left" marginBottom={1}>
                                        30 days or less before scheduled arrival: 100% of the total cost is forfeit
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" align="left" >
                                        ● For cancellations prior to 30 days, the deposit is forfeit
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" align="left" >
                                        ● For any cancellation made prior to the deadline of the 20% deposit, 100 GBP is forfeit
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" align="left" >
                                        ● For cancellations of options (transfers, pro-sport etc) 14 days or less prior to arrival, no refund will be made
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" align="left" >
                                        ● In the unlikely event that the Customer has a complaint, this must be made within 7 days of the Participant concluding the course. No claims will be considered outside this period
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" align="left" >
                                        ● In no event shall the liability of LINES to any Customer for any loss, damage or injury, howsoever incurred, sustained or suffered, exceed the total price paid by the Customer It is the responsibility of the Customer/Participant to have in his/her possession the necessary documents, visas, insurance and travel tickets at the time of departure and the time of retur
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● If you arrive late or leave early, no refunds will be made
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" align="left">
                                        ● LINES reserves the right to send home at the earliest moment a participant who is being seriously disruptive during his/her stay without any refund. The costs related to such an early return will be charged to the participant or his/her legal representatives. Reasons for expulsion: mentioned in the “School Rules” section
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" align="left" fontWeight={"bold"}>
                                        ● LINES reserves the right to charge parents for repairs or replacements for any damage caused to property by their child
                                    </Typography>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
            </Paper>

            <Grid container direction="row" justifyContent="center" alignItems="center">
                <Grid item xs={6} style={{ border: `2px solid ${isFormInvalid && !signatureFilled ? 'red' : 'black'}` }}>

                    {edit_mode ? <img src={`https://netbee.blob.core.windows.net/lines/bookings/${current_booking_id}/signature.png`} /> :
                        <SignatureCanvas ref={(ref) => { sigPad = ref }} onEnd={() => endSignature()} onBegin={() => beginSignature()} penColor='black' canvasProps={{ width: 500, height: 125, className: 'sigCanvas' }} />}

                </Grid>
            </Grid>



            {!edit_mode ?
                <Grid container direction="row" justifyContent="center" alignItems="center">
                    <Grid item xs={6}>
                        <Button onClick={clear} fullWidth variant="outlined" endIcon={<ClearIcon />}>
                            Clear
                        </Button>
                    </Grid>
                </Grid> : <></>}

            <Grid container direction="row" justifyContent="center" alignItems="center">
                <Grid item xs={12} marginTop={1}>


                    {!edit_mode && <>
                        <label>Anything else ?</label>
                        <TextField
                            id="outlined-multiline-flexible"
                            fullWidth
                            multiline
                            value={comment}
                            rows={3}
                            onChange={(e) => setComment(e.target.value)}
                            
                            inputProps={{ maxLength: 250 }}
                        />
                    </>}


                </Grid>
            </Grid>



        </div >)
}

export default FinishDetails